module.exports = __webpack_public_path__ + "public/img/image.113e1056.png";